import { Currency } from "config/constants"
import { IApiLink } from "@/types"

export interface IGetTenantSettingsDto {
    defaultCurrency: Currency
    code?: string | null
    links?: IApiLink[]
}

export default class TenantSettings {
    defaultCurrency: Currency
    code?: string

    constructor({
        defaultCurrency,
        code,
    }: IGetTenantSettingsDto) {
        this.defaultCurrency = defaultCurrency
        this.code = code ?? undefined
    }
}
